export const InventoryStatus = {
  active: 'active',
  temp_out_of_stock: 'temp_out_of_stock',
  coming_soon: 'coming_soon',
  sold_out: 'sold_out',
  free_promo: 'free_promo',
  do_not_display: 'do_not_display',
  inactive: 'inactive',
  pre_order: 'pre_order'
};

Object.freeze(InventoryStatus);
